import React from "react";
import { Badge } from "reactstrap";

const ReservationStatusBadge = ({ status }) => {
  let color;
  let displayText;

  switch (status) {
    case "CONFIRMED":
      color = "success"; // Green
      displayText = "Confirmed";
      break;
    case "PENDING":
      color = "warning"; // Yellow/Orange
      displayText = "Pending";
      break;
    case "CANCELLED":
      color = "danger"; // Red
      displayText = "Cancelled";
      break;
    case "CHECKED_IN":
      color = "info"; // Blue
      displayText = "Checked In";
      break;
    case "CHECKED_OUT":
      color = "secondary"; // Gray
      displayText = "Checked Out";
      break;
    case "RESERVED":
      color = "primary"; // Blue
      displayText = "Reserved";
      break;
    default:
      color = "light"; // Light gray for unknown status
      displayText = status || "Unknown";
  }

  return (
    <Badge 
      color={color} 
      style={{ 
        padding: "6px 12px", 
        fontSize: "12px",
        fontWeight: "500",
        borderRadius: "20px"
      }}
    >
      {displayText}
    </Badge>
  );
};

export default ReservationStatusBadge;
